module.exports = __webpack_public_path__ + "static/media/SentinelX_pin.d4e2ad2c.png";